import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';

var StarSvg = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx("svg", __assign({
    width: "244",
    height: "233",
    viewBox: "0 0 244 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      ref: ref,
      d: "M118.597 7.47826C120.107 4.41924 124.469 4.41925 125.978 7.47827L158.948 74.2826C159.548 75.4973 160.707 76.3393 162.047 76.5341L235.77 87.2466C239.146 87.7372 240.494 91.8857 238.051 94.2668L184.705 146.267C183.735 147.212 183.292 148.575 183.521 149.91L196.114 223.335C196.691 226.697 193.162 229.261 190.143 227.673L124.203 193.007C123.004 192.377 121.571 192.377 120.372 193.007L54.4326 227.673C51.4131 229.261 47.8842 226.697 48.4608 223.335L61.0542 149.91C61.2832 148.575 60.8406 147.212 59.8705 146.267L6.52411 94.2668C4.08133 91.8857 5.4293 87.7372 8.80512 87.2466L82.5281 76.5341C83.8686 76.3393 85.0274 75.4973 85.627 74.2826L118.597 7.47826Z"
    }, void 0)
  }), void 0);
});

export { StarSvg };
